export const FETCH_PROPERTIES_START = 'FETCH_PROPERTIES_START';
export const FETCH_PROPERTIES_SUCCESS = 'FETCH_PROPERTIES_SUCCESS';
export const FETCH_PROPERTIES_FAIL = 'FETCH_PROPERTIES_FAIL';

export type PropertyActionTypes =
  | typeof FETCH_PROPERTIES_START
  | typeof FETCH_PROPERTIES_SUCCESS
  | typeof FETCH_PROPERTIES_FAIL;
